var _circle, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSequencer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 38.5,
    stroke: "white",
    strokeWidth: 3
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17.5,
    y: 17.5,
    width: 9,
    height: 9,
    rx: 2.5,
    fill: "#34A832",
    stroke: "#C4C4C4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 17.5,
    y: 29.5,
    width: 9,
    height: 9,
    rx: 2.5,
    stroke: "#C4C4C4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 17.5,
    y: 41.5,
    width: 9,
    height: 9,
    rx: 2.5,
    fill: "#34A832",
    stroke: "#C4C4C4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 17.5,
    y: 53.5,
    width: 9,
    height: 9,
    rx: 2.5,
    stroke: "#C4C4C4"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 41.5,
    y: 17.5,
    width: 9,
    height: 9,
    rx: 2.5,
    fill: "#3066F0",
    stroke: "#C4C4C4"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 41.5,
    y: 29.5,
    width: 9,
    height: 9,
    rx: 2.5,
    fill: "#3066F0",
    stroke: "#C4C4C4"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 41.5,
    y: 41.5,
    width: 9,
    height: 9,
    rx: 2.5,
    fill: "#3066F0",
    stroke: "#C4C4C4"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 41.5,
    y: 53.5,
    width: 9,
    height: 9,
    rx: 2.5,
    fill: "#3066F0",
    stroke: "#C4C4C4"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 29.5,
    y: 17.5,
    width: 9,
    height: 9,
    rx: 2.5,
    stroke: "#C4C4C4"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 29.5,
    y: 29.5,
    width: 9,
    height: 9,
    rx: 2.5,
    fill: "#7C2CAD",
    stroke: "#C4C4C4"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 29.5,
    y: 41.5,
    width: 9,
    height: 9,
    rx: 2.5,
    stroke: "#C4C4C4"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 29.5,
    y: 53.5,
    width: 9,
    height: 9,
    rx: 2.5,
    stroke: "#C4C4C4"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 53.5,
    y: 17.5,
    width: 9,
    height: 9,
    rx: 2.5,
    stroke: "#C4C4C4"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 53.5,
    y: 29.5,
    width: 9,
    height: 9,
    rx: 2.5,
    stroke: "#C4C4C4"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 53.5,
    y: 41.5,
    width: 9,
    height: 9,
    rx: 2.5,
    stroke: "#C4C4C4"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 53.5,
    y: 53.5,
    width: 9,
    height: 9,
    rx: 2.5,
    fill: "#F08130",
    stroke: "#C4C4C4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSequencer);
export default __webpack_public_path__ + "static/media/sequencer.6e655240320780b2e6ac963f0cdf305d.svg";
export { ForwardRef as ReactComponent };